import type { IntlService } from 'ember-intl';

export function formatDate(
  date: Date | string | null | undefined,
  intl: IntlService,
): string {
  if (!date) {
    return '';
  }
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return intl.formatDate(dateObj, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatTags(tags: string[] | null | undefined): string {
  if (!tags || tags.length === 0) {
    return '';
  }
  const formattedTags = tags.map((tag) => {
    return tag
      .replace(/^GUEST_REVIEW_HOST_(POSITIVE|NEGATIVE)_/i, '')
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
  });
  return formattedTags.join(', ');
}

export function formatIssues(issues: string[] | null | undefined): string {
  if (!issues || issues.length === 0) {
    return '';
  }
  const formattedIssues = issues.slice(0, 3).map((issue) => {
    return issue
      .replace(/^GUEST_REVIEW_HOST_(POSITIVE|NEGATIVE)_/i, '')
      .replace(/^QUALITY_LISTING_STANDARDS_/i, '')
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
  });
  return formattedIssues.join(', ');
}

export function formatYesNo(value: boolean | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }
  return value ? 'Yes' : 'No';
}

export function formatPercentage(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }
  return `${value.toFixed(1)}%`;
}

export function formatRating(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }
  return value.toFixed(1);
}
